import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, TemplateRef, Type } from '@angular/core';

import { DialogRef } from '@app/dialog/models';
import { NgClass, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet, NgComponentOutlet } from '@angular/common';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    animations: [
        trigger('dialog', [
            state('void', style({ translate: '0 100%', opacity: 0 })),
            state('*', style({ translate: '0 0', opacity: 1 })),
            transition('* <=> *', [animate('300ms cubic-bezier(0.55, 0.30, 0.15, 0.90)')]),
        ]),
    ],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgTemplateOutlet,
        NgComponentOutlet,
    ],
})
export class DialogComponent {
  @HostBinding('@dialog')
  public dialog = true;

  public readonly contentType?: 'string' | 'template' | 'component';
  public readonly content: string | TemplateRef<any> | Type<any>;
  public readonly context: any;

  public readonly width: string | undefined;
  public readonly height: string | undefined;
  public readonly classes: string[] | undefined;
  public readonly disableCloseButton: boolean | undefined;

  constructor(private ref: DialogRef) {
    this.content = this.ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.ref.close.bind(this.ref),
      };
    } else if (this.content instanceof Type) {
      this.contentType = 'component';
    }

    this.width = this.ref.config?.width;
    this.height = this.ref.config?.height;
    this.classes = this.ref.config?.classes;
    this.disableCloseButton = this.ref.config?.disableCloseButton;
  }

  public close(): void {
    this.ref.close(null);
  }
}
